import React from "react";
import { ExternalLink } from "lucide-react";

export default function AppFooter() {
  return (
    <footer
      className="border-t border-border px-6 py-2 text-[11px] text-ink-soft bg-white flex items-center justify-end gap-1"
      data-testid="app-footer"
    >
      <span>ESG Data Platform developed for</span>
      <a
        data-testid="footer-ibpap"
        href="https://ibpap.org/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-brand font-semibold hover:underline inline-flex items-center gap-0.5"
      >
        IBPAP <ExternalLink size={10} />
      </a>
      <span>by</span>
      <a
        data-testid="footer-sustek"
        href="https://sustek.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="text-brand font-semibold hover:underline inline-flex items-center gap-0.5"
      >
        SusTek Pte Ltd <ExternalLink size={10} />
      </a>
    </footer>
  );
}
